var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a5962b8be3553f3de1cbb10b4e8df27a4364f726"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website-prod@circl-w5"]={id:"a5962b8be3553f3de1cbb10b4e8df27a4364f726"};
      